import { render, staticRenderFns } from "./TestPrint.vue?vue&type=template&id=67a043c0&"
import script from "./TestPrint.vue?vue&type=script&lang=ts&"
export * from "./TestPrint.vue?vue&type=script&lang=ts&"
import style0 from "./TestPrint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports